import AbstractService from "./AbstractService";

export default class MinibusRequestService extends AbstractService {
  url(url) {
    return `/minibus${url}`;
  }

  createRequest(request) {
    return this.http.post(this.url("/createRequest"), request);
  }

  deleteRequest(reference) {
    return this.http.delete(this.url(`/query/delete/${reference}`));
  }

  searchRequestsByDates(request) {
    const params = request;
    return this.http.get(this.url("/managment/search"), { params });
  }

  update(reference ,data) {
    return this.http.put(this.url(`/editRequest/${reference}`), data);
  }

  findMine(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/history/${reference}`), {
      params
    });
  }

  findAll(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/historyManagement/all`), {
      params
    });
  }

}
